import React, { useState } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ImpactCounters from "./components/ImpactCounters";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import FinancialToolsSection from "./components/FinancialToolsSection";
import FinancialQuiz from "./components/FinancialQuiz";
import ProjectsSection from "./components/ProjectsSection";
import LecturesSection from "./components/LecturesSection";
import ContentSection from "./components/ContentSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import ConstructionPage from "./components/ConstructionPage";
import ProjetoAguiasPage from "./components/ProjetoAguiasPage";
import ProjetoProspere from "./components/ProjetoProspere";

import PageLoader from "./components/PageLoader";
import MarqueeStrip from "./components/MarqueeStrip";
import ImageAccordionSection from "./components/ui/ImageAccordionSection";
import HeroScrollSection from "./components/ui/HeroScrollSection";
import ScrollEffects from "./components/ScrollEffects";
import "./styles/design-system.css";
import "./styles/scroll-animations.css";

// Resets scroll to top on every route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const LandingPage = () => {
  return (
    <div style={{ background: 'var(--bg-page)' }}>
      <Header />
      <main>
        <HeroSection />
        <MarqueeStrip />
        <ImageAccordionSection />
        <ImpactCounters />
        <AboutSection />
        <HeroScrollSection />
        <MarqueeStrip reverse speed={28} />
        <ServicesSection />
        <FinancialToolsSection />
        <FinancialQuiz />
        <ProjectsSection />
        <LecturesSection />
        <ContentSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

function App() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="App">
      {/* Cinematic intro loader */}
      <PageLoader onComplete={() => setLoaded(true)} />

      <Toaster
        position="top-center"
        richColors
        toastOptions={{ style: { fontFamily: 'Inter, sans-serif' } }}
      />
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/em-construcao" element={<ConstructionPage />} />
            <Route path="/projeto-aguias" element={<ProjetoAguiasPage />} />
            <Route path="/projeto-prospere" element={<ProjetoProspere />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
